import { Component, OnInit, ChangeDetectorRef, ElementRef, OnDestroy, HostListener} from '@angular/core';
import {Adm000Service} from '../../../../core/_base/_service/adm000.service';
import { Router } from '@angular/router';
import{CommonService}from '../../../../Service/common/common-service.service';
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { ADM0008Class } from '../../../../Class/ADM0008/adm0008-class';
import { ADM0008ServiceService } from '../../../../Service/ADM0008/adm0008-service.service';
import{DashboardClass} from '../../../../Class/Dashboard/dashboard-class';
import { environment } from '../../../../../environments/environment';
import { finalize } from 'rxjs/operators';
import { ADM0009ServiceService } from '../../../../Service/ADM0009/adm0009-service.service';
import { ADM0009Class } from '../../../../Class/ADM0009/adm0009-class';
import { DashboardDataServiceService } from '../../../../Service/DashboardData/dashboard-data-service.service';

//import { ADM0008Class } from 'src/app/Class/ADM0008/adm0008-class';
//import { ADM0008Class } from '../../../../../src/app/Class/ADM0008/adm0008-class';
//import { ADM0008Class } from '../../../../../Class/ADM0008/adm0008-class';
//import { ADM0008ServiceService } from '../../../../../Service/ADM0008/adm0008-service.service';
//import { ADM0008ServiceService } from '../../../../../src/app/Service/ADM0008/adm0008-service.service';
@Component({
  selector: 'kt-widget-dashboard',
  templateUrl: './widget-dashboard.component.html',
  styleUrls: ['./widget-dashboard.component.scss']
})
export class WidgetDashboardComponent implements OnInit, OnDestroy {
anniversaries:any[]=[]; 
announcements:any[]=[]; 
calendarDates: any[] = [];
selectedDateEvents: any[] = [];
approvedData: any[] = [];
groupedApproved: any = {};
showApprovedPopup = false;
showNoApprovalPopup = false;
showNoLeavePopup = false;
showNoTaskPopup = false;
currentUrl: string;
photofinalURL:string;
showMonth = false;
showYear = false;



selectedMonth: number;
selectedYear: number;

// selectedMonth: number;
// selectedYear: number;

months = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

years: number[] = [];




currentDateRef: Date = new Date();   // controls calendar
currentMonth: string = '';
currentYear: number = 0;

leaveList: any[] = [];
leaveCount: string = '0';
showLeavePopup = false;

showPopup = false;


showAnnouncementPopup = false;
showAnniversaryPopup = false;

  sections = [
    { title: 'Birthdays' },
    { title: 'Anniversaries' },
    { title: 'Announcements' }
  ];

  stats = [
  { icon: 'fas fa-users', label: 'Total Employees', value: '0', sub: 'Active Employees' },
  {
  icon: 'fas fa-tasks',
  label: 'My Tasks',
  value: '0',
  sub: 'Assigned Tasks',
  type: 'mytask'
},
  // { icon: 'fas fa-calendar', label: 'On Leave Today', value: '0', sub: 'Employees', type: 'leave'},
  {
  icon: 'fas fa-tachometer-alt',   // dashboard icon
  label: 'Dashboard',              // ✅ CHANGED
  value: '',                       // optional (can keep or remove)
  sub: 'Open Dashboard',
  type: 'dashboard'               // better rename type also
},
 {
  icon: 'fas fa-check-circle',
  label: 'Approved Requests',
  value: '0',
  sub: 'Approved',
  type: 'approved'
},
  { icon: 'fas fa-check', label: 'Approvals', value: '0', sub: 'Pending Approvals', type: 'approval'}
];

  // "Total Employees" and "Dashboard" tiles are hidden from the glance row - kept in
  // `stats` itself since other code still looks them up by label (e.g. the employee
  // count assignment below), just excluded from what's rendered.
  get visibleStats() {
    return this.stats.filter(s => s.label !== 'Total Employees' && s.label !== 'Dashboard' && s.label !== 'Approved Requests');
  }

  quickAccess = [
    { label: 'Employee Management', icon: 'fa fa-users' },
    { label: 'Leave Management', icon: 'fa fa-calendar' },
    { label: 'Payroll Management', icon: 'fa fa-credit-card' },
    { label: 'Loans & Prepayments', icon: 'fa fa-handshake' },
    { label: 'Settlements', icon: 'fa fa-file' },
    { label: 'Reports & Analytics', icon: 'fa fa-chart-line' },
    { label: 'Administration', icon: 'fa fa-cog' },
    { label: 'Settings', icon: 'fa fa-sliders-h' }
  ];
  birthdays = [
    { name: 'Mohammed Ali', role: 'HR Executive', when: 'Today', photo: 'assets/p1.jpg' },
    { name: 'Sara Khan', role: 'Accountant', when: 'Tomorrow', photo: 'assets/p2.jpg' }
  ];

events = [
  { date: '2026-04-28', time: '10:00', title: 'Team Meeting' },
  { date: '2026-04-28', time: '15:00', title: 'Code Review' },
  { date: '2026-04-29', time: '11:30', title: 'Client Call' },
  { date: '2026-04-30', time: '14:00', title: 'HR Discussion' },
  { date: '2026-04-30', time: '17:00', title: 'Submit Report' }
];

days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];


  glance = [
    { value: '1,245', label: 'Total Employees' },
    { value: '48', label: 'On Leave Today' },
    { value: 'SAR 2.45M', label: 'Payroll This Month' },
    { value: '32', label: 'Pending Requests' },
    { value: '18', label: 'Approvals' }
  ];

  widgetInnerHtml: string;

  ArrModule:any[]=[];
  GreetingsList:any[]=[];

  subModulesSelected:any[]=[];
  selectedItem:any;
  selectedSubItem:any;

  ArrMainModule:any[]=[];
  lblCompanyCode: string = '';
  lblCompanyName: string = '';
  isDataReady = false;
  lblUserName: string;
  Website:string;

	currentDate = new Date();
	currentUser: any = "";
  lblAddress:string;
  lblPin:string;
  lblNationality:string;
  lblWebsite:string;

  // Public properties
	
  tblOtherDocDetailsRowIndex : number;
	tblOtherDocDetailsArray :Array<any>=[];
  tblOtherDocDetailsReportRowIndex : number;
	tblOtherDocDetailsReportArray :Array<any>=[];
  // store previous overflow settings to restore when leaving
  private previousBodyOverflow = '';
  private previousHtmlOverflow = '';
  constructor(private changeDetectorRef: ChangeDetectorRef, private router: Router, private objAdm000Service:Adm000Service, private objCommonService:CommonService,private ADM0008service:ADM0008ServiceService,private objADM0009service:ADM0009ServiceService, 
    private elementRef:ElementRef,private ADM0009service:ADM0009ServiceService,private dashboardService: DashboardDataServiceService) { }

  ngOnInit() {   
      this.widgetInnerHtml = "";

          this.photofinalURL = "UploadFiles/DocManager/Default/photo.png";
          // this.paginatorTotal$.next(this.tickets.length);
          this.currentUrl =  environment.baseUrl.replace("api/", "");

       const today = new Date();

  this.selectedMonth = today.getMonth();
  this.selectedYear = today.getFullYear();

  // Generate year range (adjust if needed)
  for (let i = this.selectedYear - 10; i <= this.selectedYear + 10; i++) {
    this.years.push(i);
  }

  this.generateCalendar();

  this.objAdm000Service.GetCompanyDetails()
    .pipe(
      finalize(() => {
        this.isDataReady = true;
        this.changeDetectorRef.detectChanges();
      })
    )
    .subscribe(
      (dataAdm0000) => {
        this.lblCompanyCode = dataAdm0000.CompCod;
        this.lblCompanyName = dataAdm0000.CompNam;
        this.lblAddress = dataAdm0000.CompAddrs;
        this.lblPin = dataAdm0000.ZipCode;
        this.lblNationality = dataAdm0000.Nationality;
        this.lblWebsite = dataAdm0000.Website;
      },
      (error) => {
        console.error('GetCompanyDetails failed', error);
        this.lblCompanyCode = '';
        this.lblCompanyName = '';
      }
    );

this.dashboardService.pendingCount$.subscribe(count => {

  const pendingCard = this.stats.find(s => s.label === 'Approvals');

    if (pendingCard) {
      pendingCard.value = count.toString();
      this.changeDetectorRef.detectChanges(); // ✅ FORCE UI UPDATE
    }
  });


this.onLoadNotification();
 this.generateCalendar();   // 🔥 ADD THIS LINE


   this.objADM0009service.LoadGreetings().subscribe(data=>{   
 
      this.changeDetectorRef.detectChanges();
      })

  //     this.objAdm000Service.GetCompanyDetails().subscribe(dataAdm0000=>{
  //     this.lblCompanyCode = dataAdm0000.CompCod;
  //     this.lblCompanyName =dataAdm0000.CompNam;
  //     this.isDataReady = true;
  //     this.lblAddress=dataAdm0000.CompAddrs;
  //     this.lblPin=dataAdm0000.ZipCode;
  //     this.lblNationality=dataAdm0000.Nationality;
  //     this.lblWebsite=dataAdm0000.Website;
  //     this.changeDetectorRef.detectChanges();
  //   },
  //   (error) => {
  //     // set defaults if needed
  //     this.lblCompanyCode = '';
  //     this.lblCompanyName = '';
  //     this.isDataReady = true;
  //     this.changeDetectorRef.detectChanges();
  //   }
  // )

  	this.currentUser = JSON.parse(localStorage.getItem("currentUser")).EmpNam;
    this.changeDetectorRef.detectChanges();

setTimeout(() => {
  window.dispatchEvent(new Event('resize'));
  this.fitDashboardHeight();
});

    // prevent vertical scrollbar on this dashboard page
    this.previousBodyOverflow = document.body.style.overflow;
    this.previousHtmlOverflow = document.documentElement.style.overflow;

    // apply global class to suppress scrollbars even if other styles override overflow
    // document.body.classList.add('dashboard-no-scroll');
    // document.documentElement.classList.add('dashboard-no-scroll');

    // document.body.style.overflow = 'hidden';
    // document.documentElement.style.overflow = 'hidden';
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.fitDashboardHeight();
  }

  // Sizes .dashboard-container to exactly fill the remaining viewport height
  // (below the sticky toolbar/header) so the whole desktop layout - menu,
  // calendar, greetings/announcements, my tasks/approvals - fits on screen
  // with no page-level scrollbar. Only on the desktop (>1200px) layout:
  // below that, .top-grid stacks to one column (see the 1200px media query)
  // and needs its normal auto height + scroll instead.
  private fitDashboardHeight(): void {
    const containerEl: HTMLElement = this.elementRef.nativeElement.querySelector('.dashboard-container');
    if (!containerEl) { return; }

    if (window.innerWidth <= 1200) {
      containerEl.style.height = '';
      return;
    }

    const top = containerEl.getBoundingClientRect().top;
    const available = window.innerHeight - top - 12;
    containerEl.style.height = Math.max(available, 480) + 'px';
  }

    onLoadNotification()
  {
      this.ADM0009service.LoadFind().subscribe(data=>{   
        const count = data.ADM0009NewList.length;

        this.dashboardService.setPendingCount(count);
        this.GreetingsList = data.ADM0009List as ADM0009Class[];  


        // ✅ TOTAL EMPLOYEE COUNT
    const empCount = data.EmployeeList ? data.EmployeeList.length : 0;

    // find the card
    const empCard = this.stats.find(s => s.label === 'Total Employees');

    if (empCard) {
      empCard.value = empCount.toString();
    }

    const taskCount = data.TaskList ? data.TaskList.length : 0;

const taskCard = this.stats.find(s => s.label === 'My Tasks');

if (taskCard) {
  taskCard.value = taskCount.toString();
}

 // =========================
    // ✅ APPROVED REQUESTS
    // =========================
    const approvedList = this.GreetingsList.filter(x =>
      x.DocType.toLowerCase().includes('approved')
    );

    this.approvedData = approvedList;

    // count
    const approvedCard = this.stats.find(s => s.label === 'Approved Requests');
    if (approvedCard) {
      approvedCard.value = approvedList.length.toString();
    }

    // group by DocType
    this.groupedApproved = this.approvedData.reduce((acc, item) => {
      const key = item.DocType || 'Others';

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(item);
      return acc;
    }, {});

 // ===== HOLIDAYS =====
 const holidayEvents = (data.HolidayListData || []).map(h => {

      const holidayDate = new Date(h.HolidayDate);

      const formattedDate =
        holidayDate.getFullYear() + '-' +
        (holidayDate.getMonth() + 1).toString().padStart(2, '0') + '-' +
        holidayDate.getDate().toString().padStart(2, '0');

      return {
        date: formattedDate,
        time: 'Holiday',
        title: h.Holiday,
        type: 'holiday',
        holidayName: h.Holiday
      };
    });

    // ============================================
    // TASK EVENTS FROM SERVER SIDE
    // ============================================

    const taskEvents = (data.TaskList || []).map(t => {

      if (!t.TargetDate) {
        return null;
      }

      const targetDate = new Date(t.TargetDate);

      const formattedDate =
        targetDate.getFullYear() + '-' +
        (targetDate.getMonth() + 1).toString().padStart(2, '0') + '-' +
        targetDate.getDate().toString().padStart(2, '0');

      return {
        date: formattedDate,
        time: 'Task',
        title: t.TaskCaption,
        type: 'task',

        // extra info
        taskNumber: t.TaskNumber,
        taskCaption: t.TaskCaption,
        taskDescription: t.TaskDetailedDescription,
        assignedDate: t.AssignedDate,
        targetDate: t.TargetDate
      };

    }).filter(x => x != null);

    // ============================================
    // MERGE ALL EVENTS
    // ============================================

    this.events = [
      ...holidayEvents,
      ...taskEvents
    ];

    // refresh calendar
    this.generateCalendar();

  // ✅ refresh calendar
  this.generateCalendar();
        const greetings = this.GreetingsList.filter(x => x.DocType=='Greetings');
        const allowedTypes = ['Circulars', 'Events', 'Announcements', 'Banners', 'Memos'];
        console.log('All Notifications:',data.ADM0009List);

this.leaveList =data.LeaveList
  .filter(x => x.DocType =='Messages')
  .map(item => {

    const text = item.NotificationContent || '';

    let name = '';

    const match = text.match(/employee\s+(.*?)\s+is/i);
    if (match) {
      name = match[1].trim();
    }

    return {
      name: name || 'Employee',
      desc: text   // ✅ keep full content
    };
  });

    // ✅ COUNT
    this.leaveCount =  this.leaveList.length.toString();

    const leaveCard = this.stats.find(s => s.label =='On Leave Today');
    if (leaveCard) {
      leaveCard.value = this.leaveCount;
    }

        const filtered = this.GreetingsList.filter(x =>allowedTypes.includes(x.DocType));
          this.announcements = filtered.map(item => {

              const text = item.NotificationContent || '';

              // Example: extract date if present (optional)
              let day = '';
              let month = '';

              const dateMatch = text.match(/(\d{2})-(\w{3})-(\d{4})/);
              if (dateMatch) {
                day = dateMatch[1];
                month = dateMatch[2];
              }

              return {
                title: item.Title,   // Announcements / Events etc.
                desc: text,
                day: day || '--',
                month: month || '--'
              };
            });

        this.anniversaries = this.GreetingsList
          .filter(x => x.DocType == 'Greetings')
          .map(item => {

            let text = item.NotificationContent || '';
            let type = '';
            let name = '';

            if (text.toLowerCase().includes('happy birthday')) {
              type = 'Birthday';
              name = text.replace(/happy birthday/i, '').trim();
            } 
            else if (text.toLowerCase().includes('happy work anniversary')) {
              type = 'Work Anniversary';
              name = text.replace(/happy work anniversary/i, '').trim();
            }
            // Clean extra spaces
            name = name.replace(/\s+/g, ' ');

            return {
              name: name,
              years: type,
              when: 'Today',
              photoURL:item.PhotoURL
            };
          });
                this.changeDetectorRef.detectChanges();
              })




     
  }

  ngOnDestroy(): void {
    // restore default scrolling when leaving this dashboard
    // document.body.classList.remove('dashboard-no-scroll');
    // document.documentElement.classList.remove('dashboard-no-scroll');

    document.body.style.overflow = this.previousBodyOverflow || '';
    document.documentElement.style.overflow = this.previousHtmlOverflow || '';
  }

  tblOtherDocDetailsEdit(field){
   
      //var objoTable =(<HTMLFormElement>document.getElementById("tblOtherDocDetails")) ;
   
      //var oCellsCurrent = objoTable.rows.item(this.tblOtherDocDetailsRowIndex).cells;
      var url = field.PageUrl;

      this.router.navigate([url], { queryParams: { } });   
      this.changeDetectorRef.detectChanges();
      }
    
      tblOtherDocDetailsReportEdit(field){
       
        var url = field.PageUrl;

        this.router.navigate([url], { queryParams: { } });   
        this.changeDetectorRef.detectChanges();
          }

         
          tblOtherDocDetailsRemove(field){
         
            this.tblOtherDocDetailsRowIndex=null;
            const index = this.tblOtherDocDetailsArray.indexOf(field);
           var id=field.FavoriteId;

            this.ADM0008service.Delete(id).subscribe(data=>{
              if(data)
              {
                
              }
            });
         
            this.tblOtherDocDetailsArray.splice(index,1);
      
            this.changeDetectorRef.detectChanges();
          }
          tblOtherDocDetailsRemoveReport(field){
           
            this.tblOtherDocDetailsReportRowIndex=null;
            const index = this.tblOtherDocDetailsReportArray.indexOf(field);
            var id=field.FavoriteId;
            this.ADM0008service.Delete(id).subscribe(data=>{
              
            });
       
            this.tblOtherDocDetailsReportArray.splice(index,1);
      
            this.changeDetectorRef.detectChanges();
          }
 
   onLoad()
  {

    this.ADM0008service.LoadFind().subscribe(data=>{     
    this.tblOtherDocDetailsArray = data.ADM0008List as ADM0008Class[];     
    this.changeDetectorRef.detectChanges();
    })

    this.ADM0008service.LoadFindReport().subscribe(data=>{     
      this.tblOtherDocDetailsReportArray = data.ADM0008ListReport as ADM0008Class[];     
      this.changeDetectorRef.detectChanges();
      })
  
  }
  GetModules()
  {
    return this.ArrModule.filter(x=>x.IsModule==1);
  }

  GetSubmodules(moduleid)
  {
    alert(moduleid);

    // this.objAdm000Service.GetModuleHead(moduleid).subscribe(dataModeuleHead=>{
    //   this.changeDetectorRef.detectChanges();
    // })

    return this.ArrModule.filter(x=>x.FkMenuId==moduleid);
  }

  // GoToDashBoard(ModuleId)
  // {
  //   localStorage.setItem('ModuleId', JSON.stringify(ModuleId));  //Module ID
  //   window.location.href='/dashboard';
  // }

//   getModuleItem(moduleItem){
// 	this.GetSubmodules(moduleItem);
//   }

//   getMenuId(menuId?:any){
// 	this.subModulesSelected = this.GetSubmodules(menuId);
// 	this.selectedItem = menuId;
// 	this.selectedSubItem = this.subModulesSelected[0].FkMenuId;
// 	return this.subModulesSelected;
//   }

//   GetSubmodules(moduleid?:any)
//   {
//     return this.ArrModule.filter(x=>x.FkMenuId==moduleid);
//   }

//   GoToDashBoard(ModuleId)
//   {
//     localStorage.setItem('ModuleId', JSON.stringify(ModuleId));
//     window.location.href='/dashboard';
//   }

  // ngAfterViewInit() {

  // //   debugger;
  // //  var dta= document.getElementById("modulediv")as HTMLDivElement;
  // //  var dta2=dta.getElementsByTagName("li")
  //   // this.elementRef.nativeElement.querySelector('li')
  //   // .addEventListener('click', this.GoToDashBoard.bind(this));
  // }


  logout() {
		this.objCommonService.Logout().subscribe(data=>{
			localStorage.clear();
			this.router.navigate(['/auth/login']);
		})
	}

  openAnnouncementPopup() {
  this.showAnnouncementPopup = true;
}

closeAnnouncementPopup() {
  this.showAnnouncementPopup = false;
}

openAnniversaryPopup() {
  this.showAnniversaryPopup = true;
}

closeAnniversaryPopup() {
  this.showAnniversaryPopup = false;
}
generateCalendar() {

  const year = this.selectedYear;        // 🔥 changed
  const month = this.selectedMonth;      // 🔥 changed

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  this.currentMonth = this.months[month]; // 🔥 changed
  this.currentYear = year;

  this.calendarDates = [];

  // empty cells
  for (let i = 0; i < firstDay; i++) {
    this.calendarDates.push({ empty: true });
  }

  // days
  for (let i = 1; i <= daysInMonth; i++) {

    const dateStr = `${year}-${(month + 1).toString().padStart(2, '0')}-${i.toString().padStart(2, '0')}`;

    // ✅ 🔥 YOUR EVENT BINDING (KEEP THIS EXACTLY)
    const dayEvents = this.events.filter(e => e.date === dateStr);

    this.calendarDates.push({
      day: i,
      fullDate: dateStr,
      isToday: this.isToday(year, month, i),
      events: dayEvents
    });
  }

  const todayData = this.calendarDates.find(d => d.isToday);
  this.selectedDateEvents = todayData ? todayData.events : [];
}

selectDate(date) {
  this.selectedDateEvents = date.events;
  this.showPopup = true;   // ✅ open popup ONLY when clicked
}
prevMonth() {
  if (this.selectedMonth === 0) {
    this.selectedMonth = 11;
    this.selectedYear--;
  } else {
    this.selectedMonth--;
  }
  this.onMonthYearChange();
}

nextMonth() {
  if (this.selectedMonth === 11) {
    this.selectedMonth = 0;
    this.selectedYear++;
  } else {
    this.selectedMonth++;
  }
  this.onMonthYearChange();
}
isToday(year: number, month: number, day: number): boolean {
  const today = new Date();
  return (
    today.getFullYear() === year &&
    today.getMonth() === month &&
    today.getDate() === day
  );
}
closePopup() {
  this.showPopup = false;
  this.selectedDateEvents = [];
}

onCardClick(card: any) {
  if (card.type =='leave') {
     const count = Number(card.value);

  if (count === 0) {
    this.showNoLeavePopup = true; // ✅ open modal
    return;
  }
  
    this.showLeavePopup = true;
  }
  else if (card.type =='approval') {
     const count = Number(card.value);

  if (count === 0) {
    this.showNoApprovalPopup = true; // ✅ open modal
    return;
  }
  

  this.router.navigate(['/hrms/usr0070-summary']);
  }

if (card.type == 'mytask') {

  const count = Number(card.value);

  // no tasks
  if (count === 0) {
    this.showNoTaskPopup = true;
    return;
  }

  // open task page
  this.router.navigate(['/hrms/Tsk5020-find']);
}


   else if (card.type == 'approved') {
    this.showApprovedPopup = true;
  }
  else if (card.type == 'dashboard') {
  this.router.navigate(['/dashboard']); // ✅ your dashboard route
}
}
getSubText(card: any): string {
  const value = Number(card.value);

  if (value === 0) {
    switch (card.label) {
      case 'Approvals':
        return 'No Pending Approvals';

      case 'Pending Requests':
        return 'No Requests';

      case 'On Leave Today':
        return 'No Employees on Leave';

      case 'Total Employees':
        return 'No Employees';

      default:
        return '';
    }
  }

  // If value is not 0 → return original sub text
  return card.sub;
}

onMonthYearChange() {
  this.currentMonth = this.months[this.selectedMonth];
  this.currentYear = this.selectedYear;

  this.generateCalendar(); // your existing function
}

toggleMonth() {
  this.showMonth = !this.showMonth;
  this.showYear = false;
}

toggleYear() {
  this.showYear = !this.showYear;
  this.showMonth = false;
}

selectMonth(i: number, event: any) {
  event.stopPropagation();
  this.selectedMonth = i;
  this.showMonth = false;
  this.onMonthYearChange();
}

selectYear(y: number, event: any) {
  event.stopPropagation();
  this.selectedYear = y;
  this.showYear = false;
  this.onMonthYearChange();
}


/* 🔥 MAIN FIX */
updateCalendar() {
  this.currentMonth = this.months[this.selectedMonth];
  this.currentYear = this.selectedYear;

  this.generateCalendar(); // your existing logic
}
}
